import * as React from "react";
import {NavAvatar} from "../nav/NavAvatar";
import {BoothConversationPost} from "./BoothConversationPost";
import {BoothHandout} from "./BoothHandout";
import {observer} from "mobx-react";
import {action, computed, observable, toJS} from "mobx";
import {SolutionOverview} from "../solution/SolutionOverview";
import {DashboardSolution} from "../../data/entities/DashboardSolution";
import {FeedItemEntity} from "../../data/entities/FeedItemEntity";
import {FeedItem} from "../feed/FeedItem/FeedItem";
import FullPostModalData from "../../data/FullPostModalData";
import {Bundle, BundleData} from "../../data/BundleData";

import './BoothPageContent.pcss';
import {ISolutionBundle, solutionDataSource} from "../../data/SolutionDataSource";
import {OverviewHTMLBlock} from "../widgets/OverviewHTMLBlock";
import {FeedData} from "../../data/FeedData";
import {ReservationsBlock} from "components/booth/ReservationsBlock";
import {DateTime} from "luxon";
import {DateTimeHelpers} from "shared/DateTimeHelpers";
import {ResData, ResDataFactory} from "components/reservations/ResData";
import {UIState} from "data/UIState";
import {IReservation} from "shared/IReservation";
import {WCEPVimeoPlayer} from "components/booth/WCEPVimeoPlayer";
import {to} from "mathjs";
import {UIStateVendor} from "data/UIStateVendor";
import {over} from "lodash";
import {StringHelpers} from "shared/StringHelpers";

interface Props {
  booth:Bundle;
  singleBundleDashboardSolution?:DashboardSolution;  // include the Dashboard solution only if this is a one bundle solution
  solutionBundle?: ISolutionBundle;

  feedData:FeedData|null;
  user:any|null;
}

@observer
export class BoothPageContent extends React.Component<Props> {

  @observable showCurrentFeedItemDetail:boolean = false;
  @observable currentFeedItem:any;
  @observable currentFeedItemAuthor:any;
  @observable openingFullPostModal = false;
  @observable onSiteCheckInCodeword = "";
  @observable resData:ResData;
  @observable reservations:IReservation[] = [];

  constructor(props:Props) {
    super(props);
    this.loadReservations(props.booth);
  }
  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
    if(this.props.booth !== prevProps.booth) {
      this.loadReservations(this.props.booth);
    }
  }
  @action loadReservations = (booth)=> {
    this.setReservations([]);
    if (booth && booth.enableReservations && booth.resOptions) {
      ResDataFactory(booth, UIState.user, this.solutionId)
        .then((resData: ResData) => {
          this.resData = resData;
          this.setReservations(resData.reservations ? resData.reservationsNewestFirst : []);
        })
        .catch((reason) => {
          console.log(reason)
        });
    }
  }

  componentDidMount() {
    const collapsedNotificationTarget = UIState.collapsedNotificationTarget;
    if(collapsedNotificationTarget && collapsedNotificationTarget.postId) {

      setTimeout(()=>{

        // Check the conversation post
        const conversationPost = this.props.booth.conversationPost;
        if(conversationPost && collapsedNotificationTarget.postId === conversationPost._id) {
          this.openConversationPostModal();
        }

        // Check the Feed
        else if(this.feedItems && this.feedItems.length > 0) {
          for(let i=0;i<this.feedItems.length;i++) {
            if(this.feedItems[i]._post && this.feedItems[i]._post._id===collapsedNotificationTarget.postId) {
              this.openFullPostModal(this.feedItems[i]);
              break;
            }
          }
        }
      }, 1);

    }
  }

  @action setReservations = (reservations:IReservation[]) => {
    this.reservations = reservations;
  }

  @computed get feedData() {
    return this.props.feedData && this.props.feedData.feed ? this.props.feedData : null;
  }

  openFullPostModal = (feedItem:FeedItemEntity) => {
    FullPostModalData.openFeedItemInFullPostModal(feedItem, this.solutionId, this.props.booth._id);
  }

  openConversationPostModal = () => {
    FullPostModalData.openFullPostModal(this.props.booth.conversationPost, this.solutionId, this.props.booth._id, this.props.booth.presenter);
  }

  @computed get solutionId() {
    // Vendor?
    if (UIStateVendor.isLoggedIn) {
      return UIStateVendor.selectedSolutionId;
    }
    // Client
    else {
      if (this.feedData && this.feedData.solution) {
        return this.feedData.solution._id;
      } else if (this.props.solutionBundle) {
        return this.props.solutionBundle._id;
      }
    }

    return "";
  }



  @computed get feedItems() {
    const feedItems:FeedItemEntity[] = [];
    if(this.feedData) {
      for(let i=0;i<this.feedData.feed.length;i++) {
        if(this.feedData.feed[i].bundleId===this.props.booth._id) {
          feedItems.push(this.feedData.feed[i]);
        }
      }
    }
    return feedItems;
  }

  @action updateFeedItemInBrowser = (feedItem:any) => {
    if(this.feedData) {
      this.feedData.updateFeedItemInBrowser(feedItem);
    }
  }

  @computed get checkInFeedItem() {
    if(this.feedData) {
      for(let i=0;i<this.feedData.feed.length;i++) {
        if(this.feedData.feed[i].bundleId===this.props.booth._id && this.feedData.feed[i].type==='checkin') {
          return this.feedData.feed[i]
        }
      }
    }
    return null;
  }



  @computed get contentUnlocked() {
    return !(this.props.solutionBundle && this.props.solutionBundle.checkInPointValue && this.props.solutionBundle.checkInLocksContent) || this.checkInFeedItem;
  }

  @action checkCodeword = () =>{
    if(this.feedData) {
      const feedData = this.feedData;
      solutionDataSource.checkInToOnsiteBooth(feedData.solution._id, this.props.booth._id, encodeURI(this.onSiteCheckInCodeword) )
      .then((response: any) => {
        if (null != response) {
          feedData.addFeedItem(response.feedItem);
        }
      });
    }
  }

  @computed get afterCheckInItems() {
    const afterCheckInItems:string[] = [];
    const bundle = this.props.booth;

    const feedItemsWithPoints = this.feedItems.filter(item=>item._post&&item._post.pointValue>0);
    for(let i=0;i<feedItemsWithPoints.length;i++) {
      afterCheckInItems.push(('quiz'===feedItemsWithPoints[i]._post.type?"Quiz":"Post")+" worth "+feedItemsWithPoints[i]._post.pointValue+" point"+(feedItemsWithPoints[i]._post.pointValue>1?"s":""));
    }

    if(bundle.conversationPost) {
      if(bundle.conversationPost.pointValue>0) {
        afterCheckInItems.push("Conversation post "+(bundle.conversationPost.awardPointsForCommenting?"with commenting, ":"")+"worth "+bundle.conversationPost.pointValue+" point"+(bundle.conversationPost.pointValue>1?"s":""));
      } else {
        afterCheckInItems.push("Conversation post with commenting");
      }
    }

    if(bundle.paperlessHandouts.length > 0) {
      afterCheckInItems.push(bundle.paperlessHandouts.length+" Handout"+(bundle.paperlessHandouts.length>1?"s":""));
    }

    return afterCheckInItems;
  }

  render() {
    const {booth} = this.props;
    const isSingleBundleSolution = !!this.props.singleBundleDashboardSolution;

    let usesCheckInPoints = false;
    let checkInPointsAwarded = !!this.checkInFeedItem;
    let checkInPointValue = 0;

    if(this.props.solutionBundle) {
      usesCheckInPoints = undefined !== this.props.solutionBundle.checkInPointValue && this.props.solutionBundle.checkInPointValue > 0;
      if(usesCheckInPoints) {
        checkInPointValue = this.props.solutionBundle.checkInPointValue;
      }
    }

    //const showBundleHTMLContent = this.props.booth.htmlContent && this.props.booth.htmlContent.trim().length>0;
    let showCheckInBlock = false;
    if(usesCheckInPoints && !checkInPointsAwarded) {
      if(this.props.booth.enableReservations) {
        // if there are reservations
        if (this.reservations.length > 0) {
          showCheckInBlock = true;
        }
        // or if it is the day of the event
        else if (this.props.solutionBundle && this.props.solutionBundle.dateOfEvent) {
          const dateOfEvent = DateTimeHelpers.parseDateTime(this.props.solutionBundle.dateOfEvent);
          if (null != dateOfEvent && DateTime.now().hasSame(dateOfEvent, 'day')) {
            showCheckInBlock = true;
          }
        }
      } else {
        showCheckInBlock = true;
      }
    }

    const overviewHTML = booth ? StringHelpers.safeHTML(booth.htmlContent)||'' : '';
    const showBundleTopper = this.props.booth.enableReservations
      || showCheckInBlock
      || (!isSingleBundleSolution && ''!==overviewHTML)
    ;

    return (
      <div className={"boothPageContent"}>
        {booth && <>

          {booth.vimeoVideoId &&
            <div className="pwn-content video">
              <div>
                <WCEPVimeoPlayer bundleId={booth._id} videoId={booth.vimeoVideoId} title={booth.fullName} />
              </div>
            </div>
          }

          {!booth.vimeoVideoId && booth.photo &&
            <div className="pwn-content">
              <div>
                <div>
                  <img src={booth.photo} aria-hidden alt={""} />
                  <ZoomRegistrationLink bundle={booth} />
                </div>
              </div>
            </div>
          }

          <div className={"pwn-under-content"}>

            {showBundleTopper &&
              <div className={"onsite-checkin"}>

                {!isSingleBundleSolution && <OverviewHTMLBlock html={overviewHTML} />}

                <ReservationsBlock bundle={this.props.booth} reservations={this.reservations} setReservations={this.setReservations} resData={this.resData} />

                {showCheckInBlock && <>
                  <h3>Check in for {this.props.solutionBundle?.checkInPointValue} point{checkInPointValue>1?'s':''}</h3>
                  <div className={"oc-options"}>
                    <div className={"oco-scan"}>
                      <img src={"img/scan.png"} alt={"null"} aria-hidden/>
                      <p>Scan the QR Code</p>
                    </div>
                    <div className={"oco-manual"}>
                      <p>Or manually enter the codeword</p>
                      <div className={"ocom-form"}>
                        <input type={"text"} placeholder={"codeword"} value={this.onSiteCheckInCodeword} onChange={(e)=>{this.onSiteCheckInCodeword = e.target.value;}}/>
                        <button className="three-band-focus" onClick={this.checkCodeword}>Check In</button>
                      </div>
                    </div>
                  </div>
                  {!this.contentUnlocked && this.afterCheckInItems.length>0 &&
                    <div className={"oco-after-checkin-items"}>
                      <p>After Check in you can access:</p>
                      <ul>
                        {this.afterCheckInItems.map((item, idx)=><li key={idx}>{item}</li>)}
                      </ul>
                    </div>
                  }
                </>
                }
              </div>
            } {/*showBundleTopper */}

            {this.contentUnlocked && <>

              {/*<BundleOverview bundle={this.props.booth}/>*/}

              {booth.presenter &&
                <div className={"block"}>
                  <h2 className={'level2'}>At the Booth</h2>
                  <div className={"strv_row"}>
                    <div className={"strv_col"}>
                      <div className={"pwn-presenter"}>
                        <NavAvatar user={booth.presenter} variant={'large'} style={{marginRight: '8px'}}/>
                        <div className={"name_title"}>
                          <span className={"name"}>{booth.presenter.firstName}&nbsp;{booth.presenter.lastName}</span>
                          {booth.presenter.professionalTitle}
                        </div>
                      </div>
                      <p className={"bio"}>{booth.presenterStatement}</p>
                    </div>
                    {booth.manager &&
                      <div className={"strv_col"}>
                        <div className={"pwn-presenter"}>
                          <NavAvatar user={booth.manager} variant={'large'} style={{marginRight: '8px'}}/>
                          <div className={"name_title"}>
                            <span className={"name"}>{booth.manager.firstName}&nbsp;{booth.manager.lastName}</span>
                            {booth.manager.professionalTitle}
                          </div>
                        </div>
                        <p className={"bio"}>{booth.managerStatement}</p>
                      </div>
                    }
                  </div>
                </div>
              }

              {booth.conversationPost &&
                <BoothConversationPost
                  post={booth.conversationPost}
                  presenter={booth.presenter}
                  onViewFullPost={this.openConversationPostModal}
                />
              }

              {this.feedItems && this.feedItems.length > 0 &&

                <div className="content" style={{
                  overflow: 'hidden',
                  position: 'relative',
                  backgroundColor: '#F0F2F2',
                  paddingTop: '30px',
                  borderRadius: '15px',
                  marginTop: '20px',
                }}>
                  <div className="content-body">
                    <div className={"bundle-feed"}>
                      {this.feedItems.map(feedItem =>
                        <FeedItem
                          user={this.props.user}
                          key={feedItem._id}
                          feedItem={feedItem}
                          openFullPostModal={this.openFullPostModal}
                          updateFeedItem={this.updateFeedItemInBrowser}
                          feedItemContext={'bundle-feed'}
                        />
                      )}
                    </div>
                  </div>
                </div>
              }
            </>
            }
            <SolutionOverview dashboardSolution={this.props.singleBundleDashboardSolution}/>
            { this.contentUnlocked && <PaperlessHandouts booth={booth} /> }

          </div>
        </>
        }
      </div>
    );
  }
}


const PaperlessHandouts = (props:{booth:Bundle}) =>{
  if(props.booth.paperlessHandouts.length > 0) {
    return (
      <div className={"block"} style={{marginTop: '15px', boxShadow: 'none'}}>
        <h2 className={'level2'}>Download Paperless Handouts (PDFs)</h2>
        {props.booth.paperlessHandouts.map((handout, idx) => <BoothHandout key={idx} handout={handout}/>)}
      </div>
    );
  } else {
    return null;
  }
}

class ZoomRegistrationLink extends React.Component<{ bundle: Bundle }> {
  @observable copied = false;

  render() {
    const zoomRegistration = this.props.bundle.zoomRegistration;
    if (zoomRegistration && this.props.bundle.liveEvent) {
      const niceType =  BundleData.niceTypeForBundleType(this.props.bundle.type);
      return (
        <div className={'zoom-link-box'}>
          <div>
            <h2 className={'level2 byzantium'}>Link for {niceType}</h2>
            <div className={'copy-link'}>
              <span>{zoomRegistration.url}</span>
              <button onClick={() => {
                navigator.clipboard.writeText(zoomRegistration.url);
                this.copied = true;
              }}>COPY LINK
              </button>
            </div>
            <div className={'copy-status'}>{this.copied && <span>copied to clipboard</span>}</div>
          </div>
        </div>);
    } else {
      return null;
    }
  }
}
